import { navbarBlue } from "../../Classes/theme";

export default function BackgroundSvg({ color = navbarBlue }) {
    const rawSvg = `
    <svg style="isolation:isolate" viewBox="0 0 1436 718" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_81_2016)">
        <rect width="1436" height="718" fill="${color}" />
        <circle cx="1656.5" cy="831.5" r="668.5" fill="#FBC42C" />
        <path d="M731.846 64C731.846 433.202 432.548 732.5 63.3459 732.5C-305.856 732.5 -605.154 433.202 -605.154 64C-605.154 -305.202 -305.856 -604.5 63.3459 -604.5C432.548 -604.5 731.846 -305.202 731.846 64Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_81_2016">
          <rect width="1436" height="718" fill="white" />
        </clipPath>
      </defs>
    </svg>
    `;

    const encodedSvg = encodeURIComponent(rawSvg.trim());
    const backgroundImage = `url("data:image/svg+xml,${encodedSvg}")`;

    return backgroundImage;
}